import './AcHorizontalSeparator.scss'

/**
 * @author Shishir
 * @returns a ac style horizontal grey separator 
 */
export default function AcHorizontalSeparator() {
    return (
        <div className='ac-horizontal-separator'></div>
    )
}
